﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1.

export const siveApiDev = "https://sbb-sive-dev.azurewebsites.net";
export const siveApiLocal = "https://localhost:5000";
export const siveApiProd = "https://sbb-sive.azurewebsites.net";
export const siveApiTest = "https://sbb-sive-test.azurewebsites.net";
export const siveCnameDev = "https://sive-deve.sbb.ch";
export const siveCnameProd = "https://sive.sbb.ch";
export const siveCnameTest = "https://sive-test.sbb.ch";
export const siveSpaDev = "https://witty-wave-0526f8b03.2.azurestaticapps.net";
export const siveSpaLocal = "https://localhost:3000";
export const siveSpaProd = "https://red-pond-0d2c44d03.4.azurestaticapps.net";
export const siveSpaTest = "https://brave-glacier-01636d203.1.azurestaticapps.net";
